import { useEffect, useState } from "react";
import { BadgeCheck, Lock } from "lucide-react";
import { http } from "../../lib/api";
import { fmtTL } from "../../lib/format";

const sel = "px-2 py-1 text-xs border border-slate-300 rounded-md bg-white";
const r2 = (v) => Math.round(v * 100) / 100;

// Taslak hakediş özetinin altı: KDV / tevkifat seçimi + "Hakedişi Onayla" → PROJE GELİRLERİ › <Proje> HAKEDİŞ ÖDEMELERİ kalemine bağlanır, dönem kilitlenir
export default function ClaimApproveBar({ inv, onApprove, approving, testid }) {
  const [kdvRates, setKdvRates] = useState([]);
  const [tevRates, setTevRates] = useState([]);
  const [kdv, setKdv] = useState(inv.kdv_rate != null ? String(inv.kdv_rate) : "20");
  const [tev, setTev] = useState(inv.tevkifat_rate ? String(inv.tevkifat_rate) : "");
  useEffect(() => {
    http.get("/kdv-rates").then((r) => { setKdvRates(r.data); setKdv((k) => (r.data.some((x) => String(x.rate) === k) || !r.data[0] ? k : String(r.data[0].rate))); }).catch(() => {});
    http.get("/tevkifat-rates").then((r) => setTevRates(r.data)).catch(() => {});
  }, []);
  const net = inv.invoice_total ?? inv.total_amount ?? 0;
  const kdvAmt = r2(net * (parseFloat(kdv) || 0) / 100);
  const tevAmt = r2(kdvAmt * (parseFloat(tev) || 0) / 100);
  const gross = r2(net + kdvAmt - tevAmt);
  const tevOpts = tevRates.filter((t, i, a) => a.findIndex((x) => x.rate === t.rate) === i).sort((a, b) => a.rate - b.rate);
  return (
    <div className="border-t-2 border-emerald-200 bg-emerald-50/70 px-3 py-2 flex flex-wrap items-center gap-x-4 gap-y-2" data-testid={testid}>
      <div className="text-[11px] text-emerald-900 min-w-[220px] flex-1">
        <div className="font-bold uppercase tracking-wider text-[10px] inline-flex items-center gap-1"><Lock className="w-3 h-3" /> Taslak — onaylanınca dönem kilitlenir</div>
        <div className="text-emerald-800/80">PROJE GELİRLERİ › <b>{inv.project_name} HAKEDİŞ ÖDEMELERİ</b> bütçe kalemine bağlanır; {inv.period?.slice(0, 7)} dönemi için veri girişi, puantaj ve düzeltme değiştirilemez (onay kaldırılmadan).</div>
      </div>
      <label className="text-[9px] font-semibold uppercase tracking-wider text-slate-600">KDV
        <select value={kdv} onChange={(e) => { setKdv(e.target.value); if (e.target.value === "0") setTev(""); }} className={`${sel} block`} data-testid={`${testid}-kdv`}>
          {kdvRates.map((k) => <option key={k.id} value={k.rate}>{k.name} (%{k.rate})</option>)}
          {kdvRates.length === 0 && <option value="20">KDV %20</option>}
        </select>
      </label>
      <label className="text-[9px] font-semibold uppercase tracking-wider text-slate-600">Tevkifat
        <select value={tev} disabled={kdv === "0"} onChange={(e) => setTev(e.target.value)} className={`${sel} block disabled:bg-slate-50 disabled:text-slate-400`} data-testid={`${testid}-tevkifat`}>
          <option value="">Yok</option>
          {tevOpts.map((t) => <option key={t.id} value={t.rate}>{t.name}</option>)}
        </select>
      </label>
      <div className="text-[11px] text-slate-700 font-mono text-right" data-testid={`${testid}-preview`}>
        <div>Net {fmtTL(net)} + KDV {fmtTL(kdvAmt)}{tevAmt ? ` − Tevk. ${fmtTL(tevAmt)}` : ""}</div>
        <div className="font-bold text-slate-900">Fatura {fmtTL(gross)}</div>
      </div>
      <button type="button" disabled={approving} onClick={() => onApprove(inv, { kdv_rate: parseFloat(kdv) || 0, tevkifat_rate: tev ? parseFloat(tev) : null }, gross)} data-testid={`${testid}-btn`}
        className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-md bg-emerald-700 text-white text-xs font-bold uppercase tracking-wide hover:bg-emerald-800 disabled:opacity-50 transition-colors">
        <BadgeCheck className="w-4 h-4" /> {approving ? "Onaylanıyor…" : "Hakedişi Onayla"}
      </button>
    </div>
  );
}
